var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import { BlockedBadge } from "../components/BlockedBadge";
import { useOnixCodetableByNumber } from "../api/onixService";
import { ONIX_TABLES } from "../utils/onixTables";
import { formatTitleWithParts } from "../utils/formatTitleWithParts";
import { formatEditionLabel } from "../utils/formatEditionLabel";
import { onixLabel } from "../utils/onixLabel";
import { buildDateAuditColumns } from "../utils/dateAuditColumns";
var EDITION_COLUMN_WIDTH = 120;
var PUBLICATION_YEAR_COLUMN_WIDTH = 110;
var BLOCKED_COLUMN_WIDTH = 120;
export var useProductNumberTable = function (onRowClick) {
    var history = useHistory();
    var formatMessage = useIntl().formatMessage;
    var formTable = useOnixCodetableByNumber(ONIX_TABLES.PRODUCT_FORM).data;
    var tableColumns = useMemo(function () { return __spreadArray([
        {
            name: formatMessage({
                id: "ui-br-agency.product-number.table.columns.productNumber",
            }),
            key: "productNumber",
            sortable: true,
            cellRenderer: function (item) { return item.productNumber || ""; },
            clickable: true,
            onClick: onRowClick ||
                (function (item) {
                    history.push("/bragency/product-numbers?detail=".concat(item.id));
                }),
        },
        {
            name: formatMessage({
                id: "ui-br-agency.product-number.table.columns.titleData",
            }),
            key: "mainTitle",
            sortable: true,
            cellRenderer: function (item) { return formatTitleWithParts(item); },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.product-number.table.columns.contributor",
            }),
            key: "firstContributor",
            sortable: true,
            cellRenderer: function (item) {
                return item.firstContributor || "";
            },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.product-number.table.columns.editionNumber",
            }),
            key: "editionNumber",
            sortable: false,
            width: EDITION_COLUMN_WIDTH,
            cellRenderer: function (item) { return formatEditionLabel(item); },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.product-number.table.columns.publicationYear",
            }),
            key: "publicationYear",
            sortable: true,
            width: PUBLICATION_YEAR_COLUMN_WIDTH,
            cellRenderer: function (item) { return item.publicationYear || ""; },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.product-number.table.columns.publisher",
            }),
            key: "publisherName",
            sortable: true,
            cellRenderer: function (item) { return item.publisherName || ""; },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.product-number.table.columns.productForm",
            }),
            key: "productForm",
            sortable: true,
            cellRenderer: function (item) {
                return onixLabel(formTable, item.productForm);
            },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.product-number.table.columns.blocked",
            }),
            key: "blocked",
            sortable: false,
            width: BLOCKED_COLUMN_WIDTH,
            cellRenderer: function (item) { return (React.createElement(BlockedBadge, { blocked: item.blocked, blockReason: item.blockReason, blockComment: item.blockComment })); },
        }
    ], buildDateAuditColumns(formatMessage, "ui-br-agency.product-number.table.columns"), true); }, [formatMessage, history, onRowClick, formTable]);
    return {
        tableColumns: tableColumns,
    };
};
